import React, { useEffect, useState } from "react";
import Editor from "../../../elements/tiptap-editor/Editor";
import Select from "../../../form/select/Select";
import useForm from "../../../../hooks/useForm";
import Button from "../../../form/Button";
import { postAddEdit } from "../../../../services/postService";
import { useMutation, useQuery } from "@tanstack/react-query";
import Input from "../../../form/Input";
import { toast } from "react-toastify";
import { taxonomyList } from "../../../../services/taxonomyService";
import MultiselectDropdown from "../../../form/MultiselectDropdown";
import FlexibleSelect from "../../../form/select/FlexibleSelect";
import LanguageTabs from "../../../elements/LanguageSwitcher";
import { generateSlug, supportedLanguages, userLang } from "../../../../helpers";

const validation = {
  title: { required: true, message: "Question is required" },
  // content: { required: true, message: "Answer is required" },
};

const ManageFaq = ({ getResponse = () => {}, close = () => {}, data }) => {
  const [categories, setCategories] = useState([]);
  const [currentLang, setCurrentLang] = useState(userLang || "en");
  const handleLangChange = (lang) => {
    setCurrentLang(lang);
  };

  const { values, handleChange, handleSubmit, errors, setFieldsValue, resetField, formValidate } = useForm({
    validationRules: validation,
  });

  useEffect(() => {
    if (data?._id) {
      setFieldsValue({
        ...data,
        content: {
          ...supportedLanguages.reduce((acc, lang) => {
            acc[lang.code] = {
              title: data?.content?.[lang.code]?.title || "",
              subTitle: data?.content?.[lang.code]?.subTitle || "",
              content: data?.content?.[lang.code]?.content || "",
              seo: data?.content?.[lang.code]?.seo || {},
            };
            return acc;
          }, {}),
        },
        title: data?.content?.[currentLang]?.title || "",
      });
      setCategories(data?.categories);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const {
    mutate,
    error,
    isLoading: detailsLoading,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      return await postAddEdit({
        ...val,
        categories: categories,
        type: "faq",
        slug: `${generateSlug(val?.content?.[userLang]?.title.replace(/\s+/g, "-").toLowerCase(), Date.now())}`,
        lang: localStorage.getItem("lang"),
        content: val?.content,
        ...(data?._id && { id: data?._id }),
      });
    },
    onSuccess: (res) => {
      getResponse(res);
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });
  const { data: categoryData } = useQuery({
    queryKey: ["category"],
    queryFn: async () => {
      const res = await taxonomyList({
        limit: 10000,
        type: "faq-category",
      });
      if (res?.status !== 200) {
        toast.warning(res?.message);
      }
      return res?.docs;
    },
  });

  return (
    <form onSubmit={(event) => handleSubmit(event, mutate)}>
      <LanguageTabs languages={supportedLanguages} value={currentLang} onChange={handleLangChange} />
      <div className="grid grid-cols-4 gap-x-4 gap-y-4 m-4">
        <div className="relative col-span-4">
          <Input
            label={"FAQ Question"}
            inputType={"title"}
            inputPlaceholder="Question"
            inputName={`content.${currentLang}.title`}
            value={values?.content?.[currentLang]?.title || ""}
            onChange={(e) => {
              const newValue = e.target.value;
              setFieldsValue({
                ...values,
                title: newValue,
                content: {
                  ...values.content,
                  [currentLang]: {
                    ...values.content?.[currentLang],
                    title: newValue,
                  },
                },
              });
            }}
            {...formValidate(errors, "title")}
          />
        </div>
        <div className="relative col-span-4">
          <Editor
            label={"Answer"}
            height={200}
            placeholder={"Write Something"}
            value={values?.content?.[currentLang]?.content || ""}
            onChange={(val) => {
              setFieldsValue({
                ...values,
                content: {
                  ...values.content,
                  [currentLang]: {
                    ...values.content?.[currentLang],
                    content: val,
                  },
                },
              });
            }}
            // {...formValidate(errors, `content.${currentLang}.content`)}
          />
        </div>
        <div className="relative col-span-4">
          <FlexibleSelect
            label={"Select category"}
            isSearch={true}
            dropdownData={categoryData?.data?.map((item) => {
              return {
                name: item?.content?.[currentLang]?.title,
                value: item?._id,
              };
            })}
            selectedValue={categories}
            onChange={setCategories}
            type="multiple"
            placeholder="Choose categories"
          />
        </div>
      </div>
      <div className="pt-3 p-6 flex justify-end">
        <Button
          buttonType="submit"
          buttonClasses={"min-w-36"}
          buttonLabel={data?._id ? "Update" : "Save"}
          {...((isLoading || detailsLoading) && {
            loading: true,
            buttonIconPosition: "left",
            isDisable: true,
          })}
        />
      </div>
    </form>
  );
};

export default ManageFaq;
